/**
 * @generated SignedSource<<46b2bb1311d9e772182e24120e010bc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AnsweringTypeV2 = "allowMultipleAnswersAllCorrectMustBeGiven" | "allowMultipleAnswersOnlySomeCorrectMustBeGiven" | "allowOnlyOneAnswer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment$data = {
  readonly answerOptions: ReadonlyArray<{
    readonly answer: string;
    readonly image: {
      readonly url: string | null;
    } | null;
  }>;
  readonly answeringType: AnsweringTypeV2;
  readonly image: {
    readonly url: string | null;
  } | null;
  readonly question: string;
  readonly " $fragmentType": "MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment";
};
export type MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment$key = {
  readonly " $data"?: MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "question",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answeringType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerOptionV2",
      "kind": "LinkedField",
      "name": "answerOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answer",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MultipleChoiceElementV2",
  "abstractKey": null
};
})();

(node as any).hash = "3905e49ac8a7fb2f4bc291bdf60f498a";

export default node;
